<template lang="pug">
  div(class="library-container")
    div(v-if="libraryType==null")
      el-row
        h2(class="library-title") Select a Question Library
      el-row(:gutter="15")
        el-col(
          :span="12"
          v-for="(value, key) in LIBRARY_TYPES"
          :key="key"
          align="center"
        )
          div
            el-button(
              class="library-btn"
              @click="chooseType(key)"
            )
              img(
                class="library-type-img"
                :src="require(`@/assets/icons/${key}_library.svg`)"
              )

            p(class="library-type-name") {{ getLibraryName(key) }}

    div(v-else)
      el-row
        question-library(
          :libraryType="libraryType"
          @showLibraryModal="libraryType=null"
        )
</template>

<script>
import QuestionLibrary from "@/components/demo/library/QuestionLibrary";
import { LIBRARY_TYPES } from "@/defines/constants";

export default {
  name: "LibrarySelector",

  components: {
    QuestionLibrary
  },

  props: {
    type: {
      type: String,
      default: "library"
    }
  },

  data() {
    return {
      LIBRARY_TYPES,
      libraryType: null
    };
  },

  watch: {
    type() {
      this.libraryType = null;
    }
  },

  methods: {
    chooseType(type) {
      this.libraryType = type;
    },

    getLibraryName(type) {
      return type.charAt(0).toUpperCase() + type.slice(1) + " Library";
    }
  }
};
</script>

<style>
.library-container {
  padding: 1em 0 2em;
}

.library-title {
  color: var(--purple-blue);
  font-size: 1.75em;
  text-align: center;
  margin-top: 0;
  padding-bottom: 1em;
}

.library-btn {
  height: 120px;
  width: 120px;
  padding: 0;
  margin: 0;
}

.library-type-name {
  color: var(--button-blue);
  font-size: 1.5em;
  line-height: 2em;
}

.library-type-img {
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
}

.library-type-img:hover {
  filter: brightness(0.59) sepia(0.87) hue-rotate(200deg) saturate(3);
}
</style>
